import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {SearchLocationComponent} from '../search-location/search-location.component';
import {SearchMultiSelectComponent} from '../search-multi-select/search-multi-select.component';

@Component({
  selector: 'ucs-search-channel-country-variant',
  templateUrl: './search-channel-country-variant.component.html',
  styleUrls: ['./search-channel-country-variant.component.scss', '../../sidebar-template/sidebar-template.component.scss'],
  standalone: false
})
export class SearchChannelCountryVariantComponent {


    @Input() channels: any;
    @Input() countries: any;
    @Input() searchParams: any;
    @Input() isPiaAuctionScope: any;
    @Input() searchLocation: SearchLocationComponent;

    @Output() updateSearchAggregation = new EventEmitter();

    @ViewChild('dropdownCountry') dropdownCountry: SearchMultiSelectComponent;
    @ViewChild('dropdownChannel') dropdownChannel: SearchMultiSelectComponent;

    /**
     * Updates respective search param
     * @param value: the channel or channel array that should be updated in search params
     */
    onChangeSearchParamChannels(value: DistributionChannel[]) {
      this.searchParams.channels = value;
      this.updateSearchAggregation.emit(this.searchParams);
    }

    /**
     * Updates respective search param and dispatch update in redux store
     * @param value: the country or country array that should be updated in search params
     */
    onChangeSearchParamCountry(value: Country[]) {
      this.searchParams.countries = value;
      // when a country is selected, zipcode & city needs to be reset
      this.searchParams.zipCode = undefined;
      this.searchParams.city = undefined;
      this.updateSearchAggregation.emit(this.searchParams);
    }

    overrideCountries(searchParams: any) {
      this.dropdownCountry?.overrideSelection(searchParams);
    }

    overrideChannels(searchParams: any) {
      this.dropdownChannel?.overrideSelection(searchParams);
    }

    /**
     * Updates vehicle-related search params and dispatch update in redux store
     */
    onChangeVehiclesSearchParams(vehicleParams: VehicleOfferSearchParams) {
      this.searchParams.brand = vehicleParams.brand;
      this.searchParams.brand2 = vehicleParams.brand2;
      this.searchParams.brand3 = vehicleParams.brand3;
      this.searchParams.brand4 = vehicleParams.brand4;
      this.searchParams.brand5 = vehicleParams.brand5;

      this.searchParams.models = vehicleParams.models;
      this.searchParams.models2 = vehicleParams.models2;
      this.searchParams.models3 = vehicleParams.models3;
      this.searchParams.models4 = vehicleParams.models4;
      this.searchParams.models5 = vehicleParams.models5;
      this.searchParams.modelVariants = vehicleParams.modelVariants;
      this.searchParams.modelVariants2 = vehicleParams.modelVariants2;
      this.searchParams.modelVariants3 = vehicleParams.modelVariants3;
      this.searchParams.modelVariants4 = vehicleParams.modelVariants4;
      this.searchParams.modelVariants5 = vehicleParams.modelVariants5;
      this.updateSearchAggregation.emit(this.searchParams);
    }
}
